import type { BankAccountGroupSchema } from "bankconnect";
import { useState } from "react";

import type { SelectedAccount } from "../banking-accounts/utils";

export const useBankingAccountsModals = () => {
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
  const [isRequirementsModalOpen, setIsRequirementsModalOpen] = useState(false);
  const [isBankingDataDeclarationModalOpen, setIsBankingDataDeclarationModalOpen] = useState(false);
  const [isFloatingFilesListOpen, setIsFloatingFilesListOpen] = useState(false);
  const [isAccountDetailsPanelOpen, setIsAccountDetailsPanelOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState<SelectedAccount | null>(null);
  const [isGroupDetailsPanelOpen, setIsGroupDetailsPanelOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState<BankAccountGroupSchema | null>(null);
  const [isUnmatchedStatementsPanelOpen, setIsUnmatchedStatementsPanelOpen] = useState(false);

  const onSelectAccount = (account: SelectedAccount) => {
    setSelectedAccount(account);
    setIsAccountDetailsPanelOpen(true);
  };

  const onSelectGroup = (group: BankAccountGroupSchema) => {
    setSelectedGroup(group);
    setIsGroupDetailsPanelOpen(true);
  };

  return {
    isConnectModalOpen,
    setIsConnectModalOpen,
    isRequirementsModalOpen,
    setIsRequirementsModalOpen,
    isBankingDataDeclarationModalOpen,
    setIsBankingDataDeclarationModalOpen,
    isFloatingFilesListOpen,
    setIsFloatingFilesListOpen,
    isAccountDetailsPanelOpen,
    setIsAccountDetailsPanelOpen,
    selectedAccount,
    onSelectAccount,
    isGroupDetailsPanelOpen,
    setIsGroupDetailsPanelOpen,
    selectedGroup,
    onSelectGroup,
    isUnmatchedStatementsPanelOpen,
    setIsUnmatchedStatementsPanelOpen,
  };
};
